<script>
	import StepOne from './steps/StepOne';
	import StepTwo from './steps/StepTwo';
	import StepThree from './steps/StepThree';
	import StepFour from './steps/StepFour';
	import StepFive from './steps/StepFive';
	import StepSix from './steps/StepSix';
	import { mapState,mapMutations } from 'vuex';
	import { stepLayoutTarget } from '../stepsTargets.js';
	import { BulmaAccordion, BulmaAccordionItem } from "vue-bulma-accordion";

	export default{
		components:{StepOne,StepTwo,StepThree,StepFour,StepFive,StepSix,BulmaAccordion,BulmaAccordionItem},
		data(){
			return{
				statusPanel: false,
				panelHide:{'transition':'all 700ms ease 0s','right':'-210px'},
				panelShow:{'transition':'all 700ms ease 0s','right':'0'},
				myOptions:{
					labels: {
						buttonSkip: 'Saltar instrucciones',
						buttonPrevious: 'Anterior',
						buttonNext: 'Siguiente',
						buttonStop: 'Siguiente'
					}
				},
				myCallbacks:{
					onNextStep: this.myCustomNextStepCallback,
					onStop: this.myCustomStopCallback
				},
				terminatedTour:false
			}
		},
		computed:{
			...mapState(['stepActive','tiendaSeleccionada','ejercicioActivo','alertas']),
			steps(){
				return stepLayoutTarget(this.ejercicioActivo);
			}
		},
		mounted(){
			if(this.stepActive == 1){
				this.statusPanel = true;
				
				if(this.alertas){
					this.$tours['instrucciones'].start();
				}

				setTimeout(() => {
					window.$('.v-step').addClass('contente-superimposed');
				},10); 
			}
			window.EA = this.ejercicioActivo;
			// console.log(this.ejercicioActivo);
		},
		watch:{
			stepActive(){
				if(this.stepActive == 1){
					setTimeout(() => {
						window.$('.v-step').addClass('contente-superimposed');
						if(this.alertas){
							this.$tours['instrucciones'].start();
						}
					},10);
					if(this.ejercicioActivo == 'ejercicio-2' || this.ejercicioActivo == 'ejercicio-4'){
						window.$('.accordion .card:last-child > .card-header').trigger('click');
					}

					if(this.ejercicioActivo == 'evaluacion-1' || this.ejercicioActivo == 'evaluacion-2'){
						setTimeout(() => {
							window.$('.accordion .card > .card-header').trigger('click');
						},100);
					}
				}
			},
			ejercicioActivo(){
				return this.ejercicioActivo;	
			}
		},
		methods:{
			...mapMutations(['resetEmulador']),
			close(){
				this.resetEmulador();
				this.$router.push(`/`);
			},
			togglePanelEjercicios(){
				this.statusPanel = !this.statusPanel;
			},
			myCustomNextStepCallback () {
				// if (currentStep === 0) {
				// 	if(this.statusPanel){
				// 		this.togglePanelEjercicios();	
				// 	}
				// }
			},
			myCustomStopCallback(){
				this.terminatedTour = true;
			},
			getNumEjercicio(ejercicioA){
				switch(ejercicioA) {
					case 'evaluacion-1':
					return 1;
					case 'evaluacion-2':
					return 1;
					case 'ejercicio-1':
					return 1;
					case 'ejercicio-2':
					return 2;
					case 'ejercicio-3':
					return 1;
					case 'ejercicio-4':
					return 2;
				}
				return 0;
			}
		}
	}
</script>
<template>
	<div>
		<v-tour name="instrucciones" :steps="steps" :options="myOptions" :callbacks="myCallbacks"/>
		<div :class="{'container-ejercicios':statusPanel}">
			<div class="sub-ejercicios" :style="statusPanel ? panelShow:panelHide">

				<div data-v-step="1" class="tab-ejercicios" @click="togglePanelEjercicios()">
					<i class="fas fa-chalkboard-teacher"></i>
				</div>
				<div class="panel-ejercicios">
					<bulma-accordion :initial-open-item="getNumEjercicio(ejercicioActivo)">
						<bulma-accordion-item v-if="ejercicioActivo == 'evaluacion-1'">
							<p slot="title">EVALUACIÓN 1 (AUTOSERVICIO) <small v-if="ejercicioActivo == 'evaluacion-1'"><i>En progreso</i></small></p>
							<div slot="content">
								Se ingresa una aportación para el proveedor 301922 CREMERIA AMERICANA S.A. DE C.V. del 2.5 % 
								sobre Volumen de Compra para la fineline 1301 Margarinas, con distribución a todas las 
								tiendas para los formatos de Supercenter, Bodega y Superama.
								<br><br>
								

								Fecha de vigencia del Evento: Del 01/07/2019 al 31/12/2019.<br>
								Locación Corporativa 100001 Autoservicio <br>
								<!-- Base de artículos Grupo de Artículos <br> -->
								Depto 90 <br>
								Proveedor Retail Link Usuario 76TV7ED <br>
								Comprador Usuario A0F00TH <br>
								Dmm Usuario A0N00PC <br>
							</div>
						</bulma-accordion-item>
						<bulma-accordion-item v-if="ejercicioActivo == 'evaluacion-2'">
							<p slot="title">EVALUACIÓN 2 (SAM’S CLUB) <small v-if="ejercicioActivo == 'evaluacion-2'"><i>En progreso</i></small></p>
							<div slot="content">
								Se tiene un plan promocional del 01/07/2019 al 30/10/2019.
								para el proveedor 505800 ESTEVEZ S.A. DE C.V. , se debe ingresar en AMS  
								una aportación por pieza vendida del artículo 634391 ventilador 56” INDUSTR. 
								durante el periodo que dura la promoción.
								<br><br>

								Cat 94<br>
								Sub categoría 004<br>
								Locación Corporativa 100017 Sam’s Club<br>
								$431.03 x pieza Vendida<br>
								Formato Sam’s Club<br>
								Tipo de Distribución: Todos los clubs<br>
								Proveedor retail Link Usuario 4MM1H2H<br>
								Comprador Usuario A0F00TH <br>
								Dmm Usuario A0N00PC <br>
							</div>
						</bulma-accordion-item>



						<bulma-accordion-item v-if="ejercicioActivo == 'ejercicio-1' || ejercicioActivo == 'ejercicio-2'">
							<p slot="title">Ejercicio 1 (AUTOSERVICIO) <small v-if="ejercicioActivo == 'ejercicio-1'"><i>En progreso</i></small></p>
							<div slot="content">
								Se ingresa una aportación para el proveedor 389106 
								SCHETTINO HERMANOS S. DE R. del 3% sobre 
								Volumen de Compra para la fineline 2601, 
								con distribución a todas las tiendas para el formato de Superama.
								<br><br>
								

								Fecha de vigencia del Evento: Del 01/07/2019 al 31/12/2019.<br>
								Locación Corporativa 100001 Autoservicio<br>
								<!-- Base de artículos Grupo de Artículos<br> -->
								Depto 92 <br>
								Proveedor Retail Link Usuario 3FX5CB7 <br>
								Comprador Usuario A0F00TH <br>
								Dmm Usuario A0N00PC<br>
							</div>
						</bulma-accordion-item>
						<bulma-accordion-item v-if="ejercicioActivo == 'ejercicio-1' || ejercicioActivo == 'ejercicio-2'">
							<p slot="title">Ejercicio 2 (AUTOSERVICIO) <small v-if="ejercicioActivo == 'ejercicio-2'"><i>En progreso</i></small></p> 
							<div slot="content">
								Se tiene un plan promocional del 15/07/2019 al 15/09/2019 para el proveedor 208715
								CANON MEXICANA S.A. DE C.V., se debe ingresar en AMS una aportación por pieza comprada del
								artículo 100186586 CANON MULTIFUN G2100 durante el periodo que dura la promoción.<br><br>

								Locación Corporativa 100001 Autoservicio<br>
								$431.03 x pieza Comprada<br>
								Formato BODEGA<br>
								Tipo de Distribución: Todas las Tiendas<br>
								Depto 05<br>
								Proveedor Retail Link Usuario 6XZ5W48 <br>
								Comprador Usuario A0F00TH <br>
								Dmm Usuario A0N00PC<br>
							</div>
						</bulma-accordion-item>
						<bulma-accordion-item v-if="ejercicioActivo == 'ejercicio-3' || ejercicioActivo == 'ejercicio-4'">
							<p slot="title">Ejercicio 1 (SAM’S) <small v-if="ejercicioActivo == 'ejercicio-3'"><i>En progreso</i></small></p> 
							<div slot="content">
								Se ingresa una aportación para el proveedor 757695 PROCTER AND GAMBLE MEXICO del 1.7
								% sobre Volumen de Compra para el artículo 188245 9KG ACE, con distribución a todos los clubs
								para la categoría 13 Negocio SAM’S CLUB
								<br><br>

								Fecha de vigencia del Evento: Del 01/07/2019 al 31/12/2019<br>
								<!-- Base de artículos Grupo de Artículos<br> -->
								Proveedor retail Link Usuario AP0DF7J<br>
								Cat. 13<br>
								Comprador Usuario A0F00TH <br>
								Dmm Usuario A0N00PC<br>
							</div>
						</bulma-accordion-item>
						<bulma-accordion-item  v-if="ejercicioActivo == 'ejercicio-3' || ejercicioActivo == 'ejercicio-4'">
							<p slot="title">Ejercicio 2 (SAM’S) <small v-if="ejercicioActivo == 'ejercicio-4'"><i>En progreso</i></small></p> 
							<div slot="content">
								Se tiene un plan promocional del 15/07/2019 al 15/09/2019 para el proveedor
								505800 ESTEVEZ S.A. DE C.V., se debe ingresar en AMS una aportación por pieza comprada del
								artículo 634391 ventilador 56” INDUSTR. durante el periodo que dura la promoción.
								<br><br>

								Cat 94<br>
								Sub categoría 004<br>
								Locación Corporativa 100017 Sam’s Club<br>
								$431.03 x pieza Comprada<br>Formato Sam’s Club<br> 
								Tipo de Distribución: Todos los clubs<br> 
								Proveedor retail Link Usuario 4BY15UC<br> 
								Comprador Usuario A0F00TH<br>Dmm Usuario A0N00PC<br>
							</div>
						</bulma-accordion-item>
						
					</bulma-accordion>
				</div>
			</div>
		</div>
		<div class="main-container">
			<nav class="nav-first">
				<img class="logo" src="img/logo.png" alt="">

				<ul class="list-inline">
					<li class="list-inline-item">
						<a class="a-link" @click="close()"> Salir sistema</a>
					</li>
				</ul>
			</nav>
			<nav class="nav-second">
				<ul class="list-inline">
					<li class="list-inline-item">◀ Atrás</li>
					<li class="list-inline-item" style="color: #708b9c">Continuar ▶</li>

					<li class="list-inline-item">Historial</li>
					<li class="list-inline-item">Favoritos</li>
					<li class="list-inline-item">Personalizar</li>
					<li class="list-inline-item">Ayuda</li>
					<li class="list-inline-item username">Bienvenido: Emulador</li>
				</ul>
			</nav>
			<nav class="nav-third">
				<ul class="list-inline list-menu">
					<li class="list-inline-item"><a href="#">BEx</a></li>
					<li class="list-inline-item"><a href="#">Access Control 10.0</a></li>
					<li class="list-inline-item"><a href="#">Finanzas</a></li>
					<li class="list-inline-item active"><a href="#">Comercialización LATAM</a></li>
					<li class="list-inline-item"><a href="#">Reportes de BI LATAM</a></li>
				</ul>
			</nav>
			<div class="title-menu">
				Administración de Aportaciones
			</div>
			<div class="menu">
				<div>‹</div>
				<ul class="lm list-unstyled">
					<li class="first" > <a href="#">Página principal de AMS</a></li>
					<li class="first"> <a href="#">Búsqueda</a></li>
					<li class="second"> 
						<a href="#">Solicitud de acuerdo</a>
						<ul class="lm list-unstyled">
							<li class="first active" data-v-step="2"> <a href="#">Crear Nuevo / Copiar</a></li>
							<li class="first" > <a href="#">Borradores Guardados</a></li>
							<li class="first" > <a href="#">Aprobación Agilizada</a></li>
							<li class="first" > <a href="#">Carga Masiva</a></li>
						</ul>
					</li>
					<li class="second"> <a href="#">Acuerdo</a></li>
					<li class="second"> <a href="#">Reportes</a></li>
					<li class="second"> <a href="#">Reportes de BI</a></li>
					<li class="second"> <a href="#">Entrenamiento</a></li>
				</ul>
			</div>
			<div class="body">
				<div class="breadcums">
					Comercialización LATAM > Administración de Aportaciones > Solicitud de acuerdo > Crear Nuevo / Copiar
				</div>


				<step-one v-if="stepActive == 1" :terminatedTour="terminatedTour" />
				<step-two v-if="stepActive == 2"   />
				<step-three v-if="stepActive == 3" />
				<step-four v-if="stepActive == 4"  />
				<step-five v-if="stepActive == 5"  />
				<step-six v-if="stepActive == 6"   />
			</div>
		</div>
	</div>
</template>